import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["typeSelect", "optionsSection", "optionsContainer", "optionRow", "template"]

  connect() {
    this.optionIndex = this.optionRowTargets.length
  }

  toggleOptions() {
    const type = this.typeSelectTarget.value
    const showOptions = type === "simple" || type === "multiple"

    if (this.hasOptionsSectionTarget) {
      this.optionsSectionTarget.hidden = !showOptions
    }
  }

  addOption(event) {
    event.preventDefault()

    const template = this.templateTarget
    const clone = template.content.cloneNode(true)
    const input = clone.querySelector("input[type='text']")

    if (input) {
      const newIndex = Date.now()
      input.name = input.name.replace("NEW_INDEX", newIndex)
    }

    this.optionsContainerTarget.appendChild(clone)
    this.optionIndex++

    const newInput = this.optionsContainerTarget.lastElementChild.querySelector("input[type='text']")
    if (newInput) {
      newInput.focus()
    }
  }

  removeOption(event) {
    event.preventDefault()

    const optionRow = event.target.closest("[data-form-question-options-target='optionRow']")
    if (!optionRow) return

    const hiddenIdField = optionRow.querySelector("input[type='hidden'][name*='[id]']")

    if (hiddenIdField) {
      const destroyInput = document.createElement("input")
      destroyInput.type = "hidden"
      destroyInput.name = hiddenIdField.name.replace("[id]", "[_destroy]")
      destroyInput.value = "1"
      optionRow.appendChild(destroyInput)
      optionRow.hidden = true
    } else {
      optionRow.remove()
    }
  }
}
